export class WidgetCacheService {
    public static _instance: WidgetCacheService;
    public static getInstance() {
        if (!WidgetCacheService._instance) {
            WidgetCacheService._instance = new WidgetCacheService();
        }
        return WidgetCacheService._instance;
    }

    private _cache: Map<string, any>;

    constructor() {
        this._cache = new Map();
    }

    public put(id: string, value: any) {
        this._cache.set(id, value);
    }

    public get(id: string): any {
        return this._cache.get(id);
    }

    public remove(id: string) {
        this._cache.delete(id);
    }

    public removeAll() {
        this._cache.clear();
    }

    public destroy() {
        this.removeAll();
    }
}
